document.addEventListener("DOMContentLoaded", () => {
  // Function to add title to the popup
   
  const showPopup = () => { 
    const popup = document.querySelector('.gift-modal');  
    if (popup) {
      popup.style.display = 'block';  
      // addTitleToPopup();  
    }
  };
 
  setTimeout(showPopup, 500);  

  const scrollContainer = (direction) => {
    const container = document.querySelector('.gifts_list_container');
    container.scrollBy({
      left: direction === 'prev' ? -container.clientWidth : container.clientWidth,
      behavior: 'smooth'
    });
  };

  const handleAddToCart = (event) => {
    const giftItem = event.target.closest('.gift_item');
    const variantId = giftItem.getAttribute('data-variant-id');
    const threshold = giftItem.getAttribute('data-threshold');

    if (variantId && threshold) {
      addToCart(variantId, threshold);
    } else {
      console.error('Missing variantId or threshold');
    }
  };

  const addToCart = async (variantId, threshold) => {
    const giftId = Math.floor(Math.random() * 1000000 + 1000);
    const currentThreshold = threshold;

    const sectionsToRender = [
      { id: 'fostr-cart-drawer', selector: '#CartDrawer' },
      { id: 'fostr-cart-icon-bubble' }
    ];

    const fostrCart = new FostrCartGWP();
    const items = {
      0: {
        id: variantId,
        quantity: 1,
        properties: {
          _gwpType: "choose_gift",
          _gwpThreshold: currentThreshold,
          _giftId: giftId,
          __choose_gift: true
        }
      }
    };

    await fostrCart.addItem(items);
    document.querySelector('#fostr-cart-icon-bubble').click()
    document.querySelector('.gift-modal-content .close').click();
  };

  document.addEventListener('click', (event) => {
    if (event.target.id === 'prev_gifts') {
      scrollContainer('prev');
    } else if (event.target.id === 'next_gifts') {
      scrollContainer('next');
    } else if (event.target.classList.contains('gift_add_to_cart')) {
      handleAddToCart(event);
    }
  });
});